<template>
    <slot></slot>
</template>
